import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    _commodityDetailsId: Yup.number().required(requiredMessage).nullable(),
    commodityId: Yup.string().nullable(),
    pgaId: Yup.string().nullable(),
    amsCertificateNumber: Yup.string().nullable(),
    epaLicenseRequired: Yup.string().nullable(),
    epaConsentNumber: Yup.string().nullable(),
    rcraHazardousWasteTrackingNumber: Yup.string(),
    epaNetQuantity: Yup.string().nullable(),
    epaUom: Yup.string().nullable(),
  })
}

export default makeValidationSchema
